import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { CartPreviewItem } from 'projects/shared/lib/components/shared/cart/preview/item/cart-preview-item.model';

/**
 * Pipe regarding filtering of cart items. Invalid items will be returned.
 * requires an import in the decorator.
 * usage only inside the html template. NO TS CODE.
 * for ts code useage @see CartItemFilterInvalidService
 */
@Pipe({
  name: 'cartItemFilterInvalid',
  standalone: true,
  pure: false
})
export class CartItemFilterInvalidPipe implements PipeTransform {

  public transform(cartItemList: CartPreviewItem[]): CartPreviewItem[] {
    return CartItemFilterInvalidService.transform(cartItemList);
  }

}

/**
 * Pipe regarding filtering of cart items. Invalid items will be returned.
 * no import required.
 * no instance required.
 * usage only inside the ts code. NO HTML TEMPLATE.
 * for html template usage @see CartItemFilterInvalidPipe
 */
@Injectable({
  providedIn: 'root'
})
export class CartItemFilterInvalidService {

  public static transform(cartItemList: CartPreviewItem[]): CartPreviewItem[] {
    return cartItemList.filter(i => i.validationResult != undefined);
  }

}
